import moment, { Moment } from 'moment';
import { Validator } from 'ra-core';

export const validateMomentDate: Validator = (date: Moment) =>
	moment(date)?.isValid() ? null : 'Helytelen dátum';
